// redex/users/reportApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";


export async function testingListsApi(payload) {
  return await api.get(
    `${apiPath.API_URL}${apiPath.testing.testingList}`,
    { params: payload } 
  );
}
